var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"link-tile",style:({'background-color': _vm.color}),on:{"click":_vm.open}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"menu-item"},[_vm._v(_vm._s(_vm.linkname))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }